import React from 'react'
import Field from '../common/Field'

const WeFitterBiometricMeasurementDetails = (props) => {
  const sdos = props.data.structured_data_objects
  if (!sdos || sdos.length < 1) return <></>

  const data = sdos[0].data_rows
  if (!data || data.length < 1) return <></>

  const grouped = data.reduce((acc, row) => {
    const key = row.measurement_type || 'unknown'
    if (!acc[key]) acc[key] = { sum: 0, count: 0, unit: row.unit }
    acc[key].sum += Number(row.value) || 0
    acc[key].count += 1
    return acc
  }, {})

  return (
    <div className='sport-fields'>
      {Object.entries(grouped).map(([type, { sum, count, unit }]) => {
        const measurementType = type.replace(/_/g, ' ').toLowerCase()
        const title = measurementType.charAt(0).toUpperCase() + measurementType.slice(1)
        const avg = Math.round(sum / count)
        const value = `${avg} ${unit || ''}`

        return (
          <Field key={`measurement-${type}`} title={title} value={value} />
        )
      })}
    </div>
  )
}

export default WeFitterBiometricMeasurementDetails
